import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-foreground-950 text-background-50/80">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <Link to="/" className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-primary-500">
                <i className="ri-fire-line text-base text-background-50"></i>
              </div>
              <span className="text-base font-heading text-background-50 whitespace-nowrap">
                国产区精选
              </span>
            </Link>
            <p className="text-sm leading-relaxed text-background-50/60">
              汇聚海量优质国产原创内容，为用户提供最全面的国产区资源导航与分类推荐。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-medium text-background-50 mb-4">
              内容分类
            </h4>
            <ul className="space-y-2.5">
              {['影视精选', '文学创作', '音乐之声', '视觉艺术'].map((cat) => (
                <li key={cat}>
                  <Link
                    to={`/category/${cat === '影视精选' ? 'film-tv' : cat === '文学创作' ? 'literature' : cat === '音乐之声' ? 'music' : 'visual-art'}`}
                    className="text-sm text-background-50/60 hover:text-background-50 transition-colors"
                  >
                    {cat}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-medium text-background-50 mb-4">
              更多分类
            </h4>
            <ul className="space-y-2.5">
              {['科技前沿', '生活方式', '历史文化', '游戏动漫'].map((cat) => (
                <li key={cat}>
                  <Link
                    to={`/category/${cat === '科技前沿' ? 'tech' : cat === '生活方式' ? 'lifestyle' : cat === '历史文化' ? 'history-culture' : 'game-anime'}`}
                    className="text-sm text-background-50/60 hover:text-background-50 transition-colors"
                  >
                    {cat}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-medium text-background-50 mb-4">
              关于
            </h4>
            <ul className="space-y-2.5">
              <li>
                <Link to="/about" className="text-sm text-background-50/60 hover:text-background-50 transition-colors">
                  关于我们
                </Link>
              </li>
              <li>
                <span className="text-sm text-background-50/60">
                  contact@guochanqu.com
                </span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-background-50/10 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-50/40">
            &copy; {new Date().getFullYear()} 国产区精选内容聚合平台. 保留所有权利.
          </p>
          <div className="flex items-center gap-5 text-xs text-background-50/40">
            <a href="/about" className="hover:text-background-50/70 transition-colors">隐私政策</a>
            <a href="/about" className="hover:text-background-50/70 transition-colors">服务条款</a>
          </div>
        </div>
      </div>
    </footer>
  );
}